var App = App || {};

App.Helpers = (function () {
    'use strict';

    const SPLIDE_ORIGINAL_TABINDEX_ATTR = 'data-splide-original-tabindex';
    const SPLIDE_NO_TABINDEX_VALUE = '__none__';

    // Wraps tables in the given context with a responsive div if not already wrapped.
    const responsiveTables = (context) => {
        if (!context) return;

        const wrapperClass = "table-responsive";
        const tables = context.querySelectorAll("table");

        tables.forEach(table => {
            if (table._responsiveWrapped || table.parentElement?.classList.contains(wrapperClass)) {
                table._responsiveWrapped = true;
                return;
            }
            const wrapper = document.createElement("div");
            wrapper.className = wrapperClass;
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
            table._responsiveWrapped = true;
        });
    };

    // Checks if the provided href uses a known URI scheme (e.g., javascript:, mailto:, tel:)
    const isUriSchema = (href) => {
        const uriSchemes = ["javascript:", "mailto:", "tel:"];
        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    // Retrieves the value of a URL query parameter by name
    const getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    // Smoothly scrolls the page to the specified element
    const scrollToElement = (element) => {
        const top = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: 'smooth' });
    };

    const preserveSplideFocusableTabIndex = (carousel) => {
        const focusableEls = carousel.querySelectorAll('.splide__slide a[href], .splide__slide button, .splide__slide [tabindex]');

        focusableEls.forEach((el) => {
            if (el.hasAttribute(SPLIDE_ORIGINAL_TABINDEX_ATTR)) return;

            const originalTabIndex = el.getAttribute('tabindex');
            el.setAttribute(SPLIDE_ORIGINAL_TABINDEX_ATTR, originalTabIndex ?? SPLIDE_NO_TABINDEX_VALUE);
        });
    };

    const restoreSplideDestroyedTabOrder = (carousel) => {
        if (carousel.classList.contains('splide--slide')) return;

        const focusableEls = carousel.querySelectorAll(`.splide__slide [${SPLIDE_ORIGINAL_TABINDEX_ATTR}]`);

        focusableEls.forEach((el) => {
            const originalTabIndex = el.getAttribute(SPLIDE_ORIGINAL_TABINDEX_ATTR);

            if (originalTabIndex === SPLIDE_NO_TABINDEX_VALUE) {
                el.removeAttribute('tabindex');
            }
            else {
                el.setAttribute('tabindex', originalTabIndex);
            }
        });
    };

    const syncSplideTabOrder = (carousel) => {
        preserveSplideFocusableTabIndex(carousel);

        const applyTabOrder = () => restoreSplideDestroyedTabOrder(carousel);

        applyTabOrder();
        window.addEventListener('resize', applyTabOrder);

        const classObserver = new MutationObserver(applyTabOrder);
        classObserver.observe(carousel, {
            attributes: true,
            attributeFilter: ['class']
        });
    };

    // Splide does not load in PageBuilder (and perhaps other scenarios)
    const splideFallback = (carousel, options, setupFn, fallbackClass = 'splide--fallback') => {

        let mounted = false;
        let instance;

        syncSplideTabOrder(carousel);

        try {
            instance = new Splide(carousel, options);
            instance.on('mounted', function () { mounted = true; });
            if (typeof setupFn === 'function') setupFn(instance);
            instance.mount();
        }
        catch (e) {
            console.error('Splide init error:', e);
        }

        // Fallback if not mounted in 1 second
        setTimeout(function () {
            if (!mounted) {
                carousel.classList.add(fallbackClass);
                console.warn('Splide failed, fallback applied');
            }
        }, 1000);

        return instance;
    };

    return {
        responsiveTables,
        isUriSchema,
        getUrlParameter,
        scrollToElement,
        splideFallback
    };

})();
